import { useMutation } from "@apollo/client";
import { useCallback } from "react";
import { FormattedMessage } from "react-intl";

import AddParentBlock from "@components/automations/AddParentBlock";
import AutomationTimingBlockForm from "@components/automations/forms/AutomationTimingBlockForm";
import Button from "@components/buttons/Button";
import IconBase from "@components/text/IconBase";
import Heading3 from "@components/typography/Heading3";
import {
  AutomationTimingBlockDestroyDocument,
  AutomationTimingBlockDestroyMutation,
  AutomationTimingBlockDestroyMutationVariables,
  AutomationFragment as AutomationType
} from "@typing/Generated";

type AutomationTimingBlock = Extract<AutomationType["blocks"][number], { __typename: "AutomationTimingBlock" }>;

type Block = NonNullable<AutomationType["blocks"][number]>;

type Props = {
  automation: AutomationType;
  automationTimingBlock: AutomationTimingBlock;
  onBlockAdded: (block: Block) => void;
};

const AutomationTimingBlockPanel = ({ automation, automationTimingBlock, onBlockAdded }: Props) => {
  const [destroyAutomationTimingBlock] = useMutation<
    AutomationTimingBlockDestroyMutation,
    AutomationTimingBlockDestroyMutationVariables
  >(AutomationTimingBlockDestroyDocument);

  const handleDestroyBlock = useCallback(() => {
    destroyAutomationTimingBlock({ variables: { id: automationTimingBlock.id } });
  }, [automationTimingBlock.id, destroyAutomationTimingBlock]);

  return (
    <>
      <Heading3>
        <FormattedMessage id="models.automation.timingBlock" />
      </Heading3>
      {!automation.locked && (
        <Button fill="clear" onClick={handleDestroyBlock}>
          <IconBase icon="trash" slot="start" />
          <FormattedMessage id="models.automation.deleteBlock" />
        </Button>
      )}
      <AddParentBlock automation={automation} childBlock={automationTimingBlock} onBlockAdded={onBlockAdded} />
      <AutomationTimingBlockForm automationTimingBlock={automationTimingBlock} locked={automation.locked} />
    </>
  );
};

export default AutomationTimingBlockPanel;
